export enum DeviceStatusMessages {
    DEVICE_STOPPED = 'Device stopped',
    DEVICE_START_TO_MOVE_AGAIN = 'Device started to move again',
}
